import { useMutation } from '@tanstack/react-query';

import useOnAsyncError from '@/hooks/useOnAsyncError';
import { getProductUsage } from '@/lib/api/product';

const useGetProductUsage = () => {
  const handleAsyncError = useOnAsyncError();

  return useMutation({
    mutationFn: ({
      productId,
      fromDate,
      toDate,
    }: {
      productId: number;
      fromDate: Date;
      toDate: Date;
    }) => {
      const from = fromDate.toISOString();
      const to = toDate.toISOString();

      return getProductUsage(productId, from, to);
    },
    onError: handleAsyncError,
  });
};

export default useGetProductUsage;
